import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import Fish from '../game/Fish';
import Kelp from '../game/Kelp';
import { allWords, firstGrade, prePrimer, primer, secondGrade, thirdGrade } from '../game/WordBank';
import gameData from '../gameData';
import UIAssetKeys from '../UIAssetKeys';
import LevelBase from './LevelBase';

export default class Level1 extends LevelBase {
  static get KEY() { return 'Level1'; }

  constructor() {
    super({ key: Level1.KEY });
  }

  init() {
    gameData.config.level = 1;

    super.init();

    this.coral1 = null;
    this.coral2 = null;
    this.anenomes = null;
    this.seaweed1 = null;
    this.seaweed2 = null;
    this.seaweed3 = null;
    this.seaweed4 = null;

    /** @type {Phaser.GameObjects.Image[]} */
    this.doodads = [];

    /** @type {Phaser.Tweens.Tween[]} */
    this.doodTweens = [];

    this.shaderCont = null;
    this.shader = null;
    this.fishies = null;

    if (gameData.config.gameMode === 1) gameData.config.levelWordBank = prePrimer.slice();
    else if (gameData.config.gameMode === 2) gameData.config.levelWordBank = primer.slice();
    else if (gameData.config.gameMode === 3) gameData.config.levelWordBank = firstGrade.slice();
    else if (gameData.config.gameMode === 4) gameData.config.levelWordBank = secondGrade.slice();
    else if (gameData.config.gameMode === 5) gameData.config.levelWordBank = thirdGrade.slice();
    else if (gameData.config.gameMode === 6) gameData.config.levelWordBank = allWords.slice();
  }

  createNextScene () {
    super.createNextScene();

    const bg = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._5_Level_2_Lvl2_Bkgd, this.nextLvlCont).setOrigin(0);

    const kelpA2 = new Kelp(this, 'B', .25, false);
    kelpA2.scaleX *= -1;
    kelpA2.x = 200;
    const kelpA1 = new Kelp(this, 'B', .5, false);
    const kelpA = new Kelp(this, 'A', 1, false);

    const kelpB2 = new Kelp(this, 'A', .25, false);
    kelpB2.scaleX *= -1;
    kelpB2.x = 1100;
    const kelpB1 = new Kelp(this, 'A', .5, false);
    kelpB1.x = 800;
    const kelpB = new Kelp(this, 'B', 1, false);
    kelpB.x = 800;

    this.nextLvlCont.add(kelpA2);
    this.nextLvlCont.add(kelpA1);
    this.nextLvlCont.add(kelpA);
    this.nextLvlCont.add(kelpB2);
    this.nextLvlCont.add(kelpB1);
    this.nextLvlCont.add(kelpB);
  }

  createBackground () {
    super.createBackground();

    this.fishies = new Fish(this);
    this.add.existing(this.fishies);

    this.coral1 = ABCyaPhaser.Images.addImage(-10, this.scale.height + 20, UIAssetKeys._4_Level_1_Lvl1_CoralLeft, this).setOrigin(0, 1);
    this.coral2 = ABCyaPhaser.Images.addImage(this.scale.width + 10, this.scale.height + 20, UIAssetKeys._4_Level_1_Lvl1_CoralRightBkgd, this).setOrigin(1);

    this.seaweed1 = ABCyaPhaser.Images.addImage(-10, this.scale.height / 2 - 80, UIAssetKeys._4_Level_1_Lvl1_Seaweed1,this);
    this.doodads.push(this.seaweed1);

    this.seaweed2 = ABCyaPhaser.Images.addImage(-10, this.scale.height / 2 + 80, UIAssetKeys._4_Level_1_Lvl1_Seaweed2, this).setOrigin(0.1, 0.5);
    this.doodads.push(this.seaweed2);

    this.seaweed3 = ABCyaPhaser.Images.addImage(this.scale.width - 170, this.scale.height + 10, UIAssetKeys._4_Level_1_Lvl1_Seaweed3, this).setOrigin(0.5, 1);
    this.doodads.push(this.seaweed3);

    this.seaweed4 = ABCyaPhaser.Images.addImage(this.scale.width, this.scale.height / 2 + 175, UIAssetKeys._4_Level_1_Lvl1_Seaweed4, this).setOrigin(0.7, 1);
    this.doodads.push(this.seaweed4);

    this.anenomes = ABCyaPhaser.Images.addImage(this.scale.width, this.scale.height,UIAssetKeys._4_Level_1_Lvl1_Anenomes, this).setOrigin(0.9);

    for (let i = 0; i < this.doodads.length; i++) {
      this.wiggleDoodad(this.doodads[i], true, i);
    }
  }

  /**
   * 
   * @param {Phaser.GameObjects.Image} doodad 
   * @param {boolean} init 
   * @param {number} ind 
   * @returns 
   */
  wiggleDoodad (doodad, init, ind) {
    if (gameData.config.gameOver) return;

    this.tweens.killTweensOf(this.doodads[ind]);
    this.doodTweens[ind]?.stop();

    const randXScale = Phaser.Math.FloatBetween(.9, 1);
    let randYScale = Phaser.Math.FloatBetween(.95, 1);
    const randDel = Phaser.Math.Between(0, 2000);
    const randTime = Phaser.Math.Between(2000, 4000);
    const randAng = Phaser.Math.Between(-3, 3);

    if (doodad && doodad.frame.name === UIAssetKeys._4_Level_1_Lvl1_Seaweed3) randYScale = 1;

    ABCyaPhaser.Tweens.addTween(doodad, randTime, { angle: randAng, delay: randDel }, Phaser.Math.Easing.Sine.InOut);

    if (init) {
      const tween = ABCyaPhaser.Tweens.addTween(doodad, randTime, { scaleX: randXScale, scaleY: randYScale, delay: randDel }, Phaser.Math.Easing.Sine.InOut, () => {
        this.wiggleDoodad(doodad, false, ind);
      });
      this.doodTweens.push(tween);
    }
    else {
      this.doodTweens[ind] = ABCyaPhaser.Tweens.addTween(doodad, randTime, { scaleX: randXScale, scaleY: randYScale, delay: randDel }, Phaser.Math.Easing.Sine.InOut, () => {
        this.wiggleDoodad(doodad, false, ind);
      });
    }
  }

  createNav () {
    super.createNav();

    this.shaderCont = this.add.container();
  }

  createShader () {
    this.shader = this.add.rectangle(0,0,this.scale.width, this.scale.height, 0x000000).setOrigin(0)
      .setInteractive()
      .setAlpha(0);
    this.shaderCont.add(this.shader);

    ABCyaPhaser.Tweens.addTween(this.shader, 500, { alpha: 0.5 }, Phaser.Math.Easing.Linear);
  }

  hideShader () {
    ABCyaPhaser.Tweens.addTween(this.shader, 500, { alpha: 0 }, Phaser.Math.Easing.Linear, () => this.shader.destroy());

    this.sub.tweenOutSpeech();
  }

  fullClean () {
    for (let i = 0; i < this.doodads.length; i++) {
      this.doodads[i].destroy();
    }
    this.doodads = [];

    this.anenomes.destroy();
    this.coral1.destroy();
    this.coral2.destroy();

    this.fishies.cleanUp();
    this.fishies.destroy();

    super.fullClean();
  }

  cleanUp () {
    for (let i = 0; i < this.doodads.length; i++) {
      this.tweens.killTweensOf(this.doodads[i]);
      this.doodTweens[i]?.stop();
      this.doodads[i].destroy();
    }
    this.doodads = [];

    this.anenomes.destroy();
    this.coral1.destroy();
    this.coral2.destroy();

    this.fishies.cleanUp();
    this.fishies.destroy();

    super.cleanUp();
  }
}